module.exports = __webpack_public_path__ + "uarm-images/ui-icons_555555_256x240.png";